// extracted by mini-css-extract-plugin
module.exports = {"box":"BoxInfo_box__KkkkF","infoContent":"BoxInfo_infoContent__wSVLT"};